import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { usePrevious } from 'utils/hooks';
import Input from 'components/forms/Input';
import { isNil, debounce } from 'lodash';

const SearchInput = ({ value, onChange }) => {
  const [localValue, setLovalValue] = useState('');
  const prevValue = usePrevious(value);

  useEffect(() => {
    if (!isNil(value) && prevValue !== value && localValue !== value) {
      setLovalValue(value);
    }
  }, [value]);

  const debounceChange = useCallback(
    debounce((nextValue) => {
      onChange(nextValue);
    }, 400),
    [],
  );

  const handleSearch = useCallback(
    (e) => {
      const nextValue = e.target.value;
      if (nextValue !== localValue) {
        setLovalValue(nextValue);
        debounceChange(nextValue);
      }
    },
    [localValue, debounceChange],
  );

  return (
    <Input
      inputProps={{ type: 'search' }}
      rightIcon="search"
      placeholder="Search"
      value={localValue}
      onChange={handleSearch}
    />
  );
};

SearchInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};

SearchInput.defaultProps = {
  onChange: () => {},
  value: '',
};

export default SearchInput;
